import VacanciesFilters from './VacanciesFilters.component';

export default VacanciesFilters;
